import React, { useState, useEffect } from 'react';
import GoogleMapReact from 'google-map-react';
import * as styles from './map.module.scss';
import { Marker } from './marker/Marker';

export interface IMapProps {
  lat: number;
  lng: number;
  zoom: number;
  center: number[];
  setCenter: (arr: number[]) => void;
}

export const Map = ({ lat, lng, zoom, center, setCenter }: IMapProps) => {
  const googleApiKey = process.env.GATSBY_GOOGLE_MAP_API;

  return (
    <div className={styles.mapWrapper}>
      <GoogleMapReact
        bootstrapURLKeys={{ key: googleApiKey ?? '' }}
        center={{ lat: center[0], lng: center[1] }}
        zoom={zoom}
        options={{ zoomControl: false, styles: mapStyle }}
        onChange={(e) => setCenter([e.center.lat, e.center.lng])}
      >
        <Marker lat={lat} lng={lng} />
      </GoogleMapReact>
    </div>
  );
};

const mapStyle = [
  {
    featureType: 'landscape',
    stylers: [
      {
        color: '#fdf7f0',
      },
      {
        weight: 2,
      },
    ],
  },
  {
    featureType: 'road',
    stylers: [
      {
        visibility: 'simplified',
      },
    ],
  },
  {
    featureType: 'road',
    elementType: 'geometry.stroke',
    stylers: [
      {
        color: '#252422',
      },
      {
        visibility: 'simplified',
      },
    ],
  },
  {
    featureType: 'road.highway',
    elementType: 'geometry.fill',
    stylers: [
      {
        color: '#ede4de',
      },
    ],
  },
  {
    featureType: 'road.highway',
    elementType: 'geometry.stroke',
    stylers: [
      {
        color: '#928b87',
      },
    ],
  },
];
